import styles from "./styles.module.css";
import { importCSV } from "../../../utils/databaseactions";
import { UserValue } from "../../../contexts/user";
import { useEffect, useState, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import { MdClose } from "react-icons/md";
import Modal from "../../../modal";

export default function ImportModal({ table, fields, setOpen, open, updateData }) {
  const [file, setFile] = useState(null);
  const [fnIsRunning, setFnIsRunning] = useState(false);
  const [dataFields, setDataFields] = useState(null);
  const [title, setTitle] = useState("choose a file");
  const { appId } = useParams();
  const inputRef = useRef(null);
  const user = useContext(UserValue);
  
  useEffect(() => {
    setFile(null);
    setFnIsRunning(false);
  }, [table, open]);

  useEffect(() => {
    if (!!file) setTitle(file.name);
    else setTitle("choose a file");
  }, [file]);

  useEffect(() => {
    if (!!fields) {
      const fieldMappings = {};
      Object.keys(fields)
      .filter(cur => fields[cur].editable)
      .forEach(id => {
        fieldMappings[fields[id].name] = id;
       });
      setDataFields(fieldMappings);
    }
  }, [fields]);

  const handleUpload = (e) => {
    setFile(e.target.files[0]);
  }

  const submit = () => {
    if (!!file) {
      const reader = new FileReader();
      reader.readAsText(file, "UTF-8");
      reader.onload = (e) => {
        console.log("submitting file for import");
        setTitle("Importing...");
        setFnIsRunning(true);
        importCSV(appId, table, e.target.result, dataFields, user)
        .then(results => {
          console.log(results.data);
          setTitle("Import complete");
          updateData();
        })
        .catch(err => {
          console.log(err);
          setTitle("An error occurred during import");
        })
        .finally(() => setOpen(false));
      }
      reader.onerror = (e) => {
        console.log("error reading file");
        setOpen(false);
      }
    }
  }

  return (
    <Modal onClose={() => setOpen(false)} open={open}>
      <div className={styles.form}>
        <div className={styles.formTitle}>
          Import CSV
          <MdClose onClick={() => setOpen(false)} className="icon" />
        </div>
        <div className={styles.formContainer}>
          <div onClick={() => inputRef.current.click()} className={styles.importButton}>
            {title}
            <input 
              ref={inputRef}
              onChange={handleUpload}
              className={styles.import} 
              type="file"
              accept="csv"
            />
          </div>
        </div>
        <div className={styles.formContainer}>
          {fnIsRunning ? null : (
            <button disabled={!file} onClick={submit}>
              Submit
            </button>
          )}
        </div>
      </div>
    </Modal>
  )
}